import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-eca-ghost-btn',
  templateUrl: './eca-ghost-btn.component.html',
  styleUrls: ['./eca-ghost-btn.component.scss']
})
export class EcaGhostBtnComponent implements OnInit {
  @Input() btnText: string;
  @Input() btnIcon: any;
  @Input() btnType: string;
  @Input() btnSize: any = '';
  @Input() disable: boolean = false;
  @Input() removeLabelOnMobile: boolean = true;
  @Output() btnClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

  getButtonClass(): string {
    let btnClass = 'btn-ghost ';

    if (this.btnType === 'success') {
      btnClass += ' btn-ghost-our-success';
    } else if (this.btnType === 'warning') {
      btnClass += ' btn-ghost-our-warning';
    } else if (this.btnType === 'danger') {
      btnClass += ' btn-ghost-our-danger';
    } else {
      btnClass += ' btn-ghost-our-primary';
    }

    if (this.btnSize === 'lg') {
      btnClass += ' btn-ghost-our-lg';
    } else if (this.btnSize === 'sm') {
      btnClass += ' btn-ghost-our-lg';
    } else {
      btnClass += ' btn-ghost-our-regular';
    }

    if (this.removeLabelOnMobile) {
      btnClass += ' btn-size';
    }
    return btnClass;
  }

  clicked() {
    this.btnClicked.emit()
  }
}
